import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageShell } from "@/components/PageShell";
import { useAuth } from "@/context/AuthContext";
import { authApi, apiError } from "@/lib/api";
import { useLang } from "@/i18n";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { t } = useLang();
  const { openAuth } = useAuth();
  const [password, setPassword] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError(t("La password deve contenere almeno 8 caratteri.")); return; }
    setState("busy"); setError("");
    try { await authApi.reset(token, password); setState("done"); }
    catch (err) { setError(t(apiError(err))); setState("idle"); }
  };

  return (
    <PageShell testId="reset-password-page" eyebrow="TripSaver" title={t("Reimposta password")}>
      <div className="max-w-md rounded-3xl border border-emerald-100 bg-white p-8">
        {state === "done" ? (
          <div className="space-y-5">
            <p data-testid="reset-success" className="flex items-center gap-2 font-semibold text-emerald-800"><CheckCircle2 className="h-5 w-5" />{t("Password aggiornata! Ora puoi accedere.")}</p>
            <button data-testid="reset-login-button" onClick={() => openAuth()} className="rounded-full bg-emerald-600 px-6 py-3 font-semibold text-white hover:bg-emerald-700">{t("Accedi")}</button>
          </div>
        ) : !token ? (
          <p data-testid="reset-invalid" className="text-red-700">{t("Link non valido o scaduto")}</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="reset-password-input" type="password" placeholder={t("Nuova password (min. 8 caratteri)")} value={password} onChange={(e) => setPassword(e.target.value)} required className="h-12 rounded-xl" />
            {error && <p data-testid="reset-error" className="rounded-xl bg-red-50 px-4 py-2 text-sm text-red-700">{error}</p>}
            <button type="submit" data-testid="reset-submit-button" disabled={state === "busy"}
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-emerald-600 py-3 font-semibold text-white hover:bg-emerald-700 disabled:opacity-60">
              {state === "busy" && <Loader2 className="h-4 w-4 animate-spin" />}{t("Salva nuova password")}
            </button>
          </form>
        )}
      </div>
    </PageShell>
  );
}
